import {inlineError} from '@s-ui/decorators/lib/index.js'
import {UseCase} from '@s-ui/domain'

import {UploadBuyerIdRequestTransactionsValueObject} from '../ValueObjects/UploadBuyerIdRequestTransactionsValueObject.js'

/**
 * @implements UseCase
 */
export class UploadBuyerIdTransactionsUseCase extends UseCase {
  constructor({httpTransactionsRepository}) {
    super()
    this._httpTransactionsRepository = httpTransactionsRepository
  }

  @inlineError
  async execute({documentBack, documentFront, tradeId}) {
    const uploadBuyerIdRequestTransactionsValueObject = UploadBuyerIdRequestTransactionsValueObject.create({
      documentBack,
      documentFront,
      tradeId
    })

    const [error] = await this._httpTransactionsRepository.uploadBuyerId(uploadBuyerIdRequestTransactionsValueObject)

    if (error) return Promise.reject(error)
  }
}
